import React, { useState, useEffect } from "react";
import { message } from "antd";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { findSellerOrdersGroupClientEvent } from '../../../_events/sellers/find_orders.event';
import { Button, Divider } from "@mui/material";
import InfoOrderModal from "../orders_history/info_order_modal";
const ID_PANEL = 'panel_pocket_balance';


const SellerOrdersGroupClient = (props) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const findData = () => {
        setLoading(true);
        findSellerOrdersGroupClientEvent()
        .then(data => {
            setData(data.list);
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    };

    useEffect(() => {
        findData();
    }, []);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return(
            <div style={{height:450, width: '100%', overflow: 'auto' }}>
                <Button variant="contained" size="small" onClick={() => props.goBack()}>Listado general</Button>
                {
                    data.map((d, key) => (
                        <Accordion key={`${ID_PANEL}${key}`} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`${ID_PANEL}${key}bh-content`}
                                id={`${ID_PANEL}${key}bh-header`}
                                >
                                <Typography sx={{ width: '60%', flexShrink: 0 }}>
                                    {d.key}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{width: '100%'}}>
                                    <AccordionInfo data={d.data} />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </div>
        );
    }
}

const AccordionInfo = (props) => {
    return(
        <div>
        {
            props.data.length === 0 ? (
             <>No hay datos</>
            ) : (
            <div style={{width: '100%'}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Número</div>
                    <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Cliente</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Detalle</div>
                </div>
                <div style={{width: '100%'}}>
                {
                    props.data.map((d, key) => {
                        return(
                            <div key={key} style={{width: '100%'}}>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                    <div style={{width: '30%', fontSize:'10px'}}>{d.date_created}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}>{d.id}</div>
                                    <div style={{width: '30%', fontSize:'10px'}}>{d.ordersDetail[0].productPrice.client.name}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}><InfoOrderModal data={d.ordersDetail} order={d} /></div>
                                </div>
                                <Divider />
                            </div>
                        )
                    })
                }
                </div>
            </div>
            )
         }
        </div>
    );
}

export default SellerOrdersGroupClient;